import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { FC } from 'react'

import { Project } from '@/api/models/auth/lib/auth.types'
import { useSelectedProject } from '@/api/models/main/hooks/useSelectedProject'
import { cn } from '@/app/utils'
import { AppCopyToClipboard } from '@/components/shared/copy-to-clipboard'
import { AppDisclosure } from '@/components/shared/disclosure'

type Props = {
  project: Project
}

const UserProfileProject: FC<Props> = ({ project }) => {
  const { selectedProject } = useSelectedProject()

  return (
    <AppDisclosure
      key={project.bc_guid}
      buttonRender={
        <div className="flex gap-4">
          {selectedProject?.bc_guid === project.bc_guid && (
            <CheckCircleIcon
              className={cn(
                'mr-4 h-20 w-20 self-center text-bronze-40',
                'sm:mr-0 sm:h-16 sm:w-16'
              )}
            />
          )}
          <div>{project.bc_name}</div>
          <div className="text-bronze-40 text-16 sm:text-12">
            {project.premises.length}
          </div>
        </div>
      }
      buttonClassName="bg-white font-bold !p-16 !text-20 hover:bg-white sm:!text-16"
      panelClassName="mt-0"
      className="rounded-12 bg-white"
    >
      <ul className="m-16 mt-0 flex flex-col gap-16">
        {project.allPremises.map(premise => (
          <li key={premise.id} className="flex text-grey-80 text-16 sm:text-14">
            <div>{premise.name}</div>
            <div className="mx-4 h-17 flex-grow border-b border-dashed text-grey-50" />
            <div className="flex gap-4">
              <div>ЛС:</div>
              <div className="text-grey-100 underline">{premise.number}</div>
              <AppCopyToClipboard
                text={premise.number}
                message="Скопирован номер лицевого счёта"
              />
            </div>
          </li>
        ))}
      </ul>
    </AppDisclosure>
  )
}

export default UserProfileProject
